export const handleKeyPressOnlyNumbers = (event) => {
  const keyCode = event.keyCode || event.which;
  const keyValue = String.fromCharCode(keyCode);

  // Allow numbers and negative sign
  if (!/[\d-]/.test(keyValue)) {
    event.preventDefault();
  }
};

export const checkPercetage = (value) => {
  if (value < 0 || value > 100) return false;
  else return true;
};

export const handleKeyPressFolderPath = (event) => {
  const keyCode = event.keyCode || event.which;
  const keyValue = String.fromCharCode(keyCode);

  if (!/[^\\/:*?"<>|]+/.test(keyValue)) {
    event.preventDefault();
  }
};
